// Simple localStorage-backed toggle for verbose error capture.
// When enabled, the error logger bypasses de-duplication and stores extra
// diagnostic context so the next reproduction of an error is guaranteed
// to be saved with full details.

const KEY = "bc.debug_logging";

export function isDebugLoggingEnabled(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setDebugLogging(on: boolean) {
  if (typeof window === "undefined") return;
  try {
    if (on) window.localStorage.setItem(KEY, "1");
    else window.localStorage.removeItem(KEY);
  } catch {}
}
